<template>
  <div>
    <mdb-modal :show="modal" @close="closeModal()" size="lg">
      <mdb-modal-header>
        <mdb-modal-title>Achtung!</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <h2>Bitte benutzen Sie eine private Email.</h2>
        <h3>Ihr International Office</h3>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="primary" @click.native="closeModal()">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <div class="container full-height">
      <h1>{{$t('Register.Vermieter.Headline')}}</h1>
      <form @submit.prevent="register" class="full-height">
        <!-- Stepers Wrapper -->
        <div class="step-wrapper full-height">
          <div class="step step-1" v-if="step == 1">
            <h2>Benutzerinformationen / User information</h2>
            <mdb-input label="E-Mail-adresse" type="email" v-model="user.email" v-on:blur="validateEmail"/>
            <mdb-input type="password" label="Passwort" v-model="user.password" />
            <mdb-input type="password" label="Passwort bestätigen" v-model="user.password_confirmation" />
          </div>

          <div class="step step-2" v-else-if="step == 2">
            <h2>Persönliche Daten / Personal information</h2>
            <div class="row">
              <div class="col-6">
                <mdb-input label="Vorname" v-model="user.vorname" />
              </div>
              <div class="col-6">
                <mdb-input label="Nachname" v-model="user.nachname" />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <mdb-input label="Straße" v-model="user.strasse" />
              </div>
              <div class="col-6">
                <mdb-input label="PLZ" v-model="user.plz" />
              </div>
            </div>


            <mdb-input label="Ort" v-model="user.ort" />
            <div class="row">
              <div class="col-6">
                <mdb-input label="Telefon*" v-model="user.telefon" />
              </div>
              <div class="col-6">
                <mdb-input label="Mobil*" v-model="user.mobil" />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <mdb-input label="Fax" v-model="user.fax" />
              </div>
            </div>
          </div>

          <div class="step step-4" v-else-if="step == 3">
            <h2 class="mb-5">Datenschutz</h2>

            <div class="row ">
              <div class="form-check mb-3">
                <a href="/nutzerbedingungenVermieter" target="_blank">
                  Nutzungsbedingungen für die Wohnungsdatenbank des International Office für Vermieterinnen und Vermieter
                </a>
              </div>

              <!-- Group of material radios - option 1 -->
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="terms" name="terms" value="terms" required v-model="terms.term1">
                <label class="form-check-label" for="terms">Hiermit stimme ich zu, dass meine angegebenen Daten zum Wohnungsangebot sowie meine persönlichen Daten zur Kontaktaufnahme durch die Wohnungssuchenden eingesehen werden können.</label>
              </div>
              <!-- Group of material radios - option 1 -->
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="terms2" name="terms2" value="terms2" required v-model="terms.term2">
                <label class="form-check-label" for="terms2">Die Nutzungsbedingungen für Vermieter habe ich zur Kenntnis genommen und stimme diesen zu.</label>
              </div>
            </div>
          </div>
        </div>
        <!-- /.Stepers Wrapper -->
        <div class="d-flex mb-5 justify-content-between align-items-center">
          <div>
            <mdb-btn color="primary" @click.native.prevent="prev()" v-bind:class="{ active: step > 1 }">Vorherige Seite</mdb-btn>
          </div>

          <div class="mr-5 gutter"></div>
          <div class="flex-1">
            <mdb-progress :value="(this.step/3 * 100)" />
          </div>
          <div class="mr-5 gutter"></div>
          <div v-if="step !== 3" v-bind:class="{ active: step <= 3 }" >
            <mdb-btn color="primary"   @click.native.prevent="next()">Nächste Seite</mdb-btn>
          </div>
          <div v-else class="">
            <mdb-btn color="primary"   @click.native.prevent="register()">Benutzer erstellen</mdb-btn>
          </div>



        </div>


      </form>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import countrySelect from "vue-country-select";
import UserService from "@/services/UserService";
import EmailService from "@/services/EmailService";
 import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, modal, mdbProgress } from 'mdbvue';
export default {
  components:{
    countrySelect,
    mdbDatePicker,
    mdbBtn,
    mdbInput,
    mdbSelect,
    mdbProgress
  },
  props:['type'],
  data() {
    return {
      user: {
        type: 2,
        email: "",
        vorname:"",
        nachname:"",
        strasse: "",
        plz: "",
        ort: "",
        telefon: "",
        mobil: "",
        fax: "",
        password:"",
        password_confirmation:"",
        expirationdate: null,
        activationhash: null

      },
      terms:{
        term1: false,
        term2: false,
      },
      emailValid: true,
      step: 1,
      modal: true
    };
  },
  methods: {
    hashCode(str) {
      let hash = 0, i, chr, len;
      if (str.length === 0) return hash;
      for (i = 0, len = str.length; i < len; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
    register: function() {
      if(!this.terms.term1 || !this.terms.term2){
        this.$notify.warn({
          message: "Bitte bestätigen Sie den Datenschutz.",
          position: 'top right',
          timeOut: 4000
        });
        return
      }

      this.user.expirationdate = "1980-01-01";
      this.user.activationhash = this.hashCode(this.user.email);
      let oldUser = this.user;

      let _this = this;
      this.$store.dispatch("register", this.user).then(response => {
        //this.$store.dispatch("login", {username: this.user.email, password: this.user.password})
        EmailService.sendMail("RegistrierungVermieter", "Registrierung", this.user.email, null, true);
        this.$notify.info({
          message: this.$t("Register.Vermieter.ConfirmNeeded"),
          position: 'top right',
          timeOut: 8000
        });
        UserService.login(_this.user.email, _this.user.password).then(response => {
        this.$router.push({name: 'home'})
        })
            .catch(e => {
              this.$notify.warn({
                message: "Ihr Account konnte nicht erstellt werden!",
                position: 'top right',
                timeOut: 4000
              });
            });
      })

    },
    validateEmail(){
      UserService.validateEmail(this.user.email).then(response =>{
        this.emailValid = response.data;

      })
    },
    closeModal(){
      this.modal = false;
    },
    next(){

      if (this.step == 4){ return }
      if(this.step == 1){
        if(this.user.password && this.user.password != "" && this.user.email && this.user.email != ""){
          if(!this.emailValid){
            this.$notify.error({
              message: "Email wird bereits verwendet.",
              position: 'top right',
              timeOut: 4000
            });
            return
          }
          if(this.user.email.indexOf("@uni-freiburg.de") != -1){
            this.$notify.error({
              message: "Keine gültige Email.",
              position: 'top right',
              timeOut: 4000
            });
          } else {
            if(this.user.password == this.user.password_confirmation){
              this.step++;
            } else {
              this.$notify.error({
                message: "Passwort stimmt nicht überein.",
                position: 'top right',
                timeOut: 4000
              });
            }
          }

        }
        else {
          this.$notify.error({
            message: "Bitte alle Angaben ausfüllen.",
            position: 'top right',
            timeOut: 4000
          });
        }
      } else if(this.step == 2){
        if(this.user.telefon == '' && this.user.mobil == ''){
          this.$notify.error({
            message: "Bitte Handy/Telefonnummer eingeben.",
            position: 'top right',
            timeOut: 4000
          });
        } else {
          this.step++;
        }
      } else{
        this.step++;
      }
        

    },
    prev(){
        if (this.step == 1){ return}
          this.step--;
    
    }

  },
   computed: {

   }
};
</script>
